<template>
    <div class="input-group" :style="fieldStyles()">
      <field-icon :fieldData="fieldData"></field-icon>

      <input
        :disabled="(!!showDisabled())"
        type="number"
        :ref="fieldData.field_name"
        :aria-describedby="`${fieldData.field_name}_describedby`"
        :id="fieldData.field_name"
        :name="fieldData.field_name"
        v-model="fieldData.field_value"
        v-validate="field_rules"
        @keypress="isNumber($event)"
        @blur="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) :  ''"
        :placeholder="fieldData.placeholder"
        :maxlength="fieldData.max_length"
        v-bind:class="{'form-control': true,
          'error': errors.has(fieldData.field_name)  || fieldData.has_error }">
          <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
    </div>
</template>

<script>
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  methods: {
    /**
     * The validation message overlaps the interactive form element, so it is cleared
     * once the components containing the element is clicked.
     */
    clearMessages() {
      this.fieldData.has_error = false; // Reset API errors to false upon any interaction
      this.errors.remove(this.fieldData.field_name); // Temporarily hide the validation message
    },
    isNumber(evt = window.event) {
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
  },
  created() {
    if (this.$store.getters.getPageName !== 'NamedInsured' &&
      this.$store.getters.getPageName !== 'HONamedInsured' &&
      this.$store.getters.getPageName !== 'CONamedInsured' &&
      this.$store.getters.getPageName !== 'RENamedInsured') { // TODO: Use config values
      // do not execute below code for Named insured page
      this.fieldData.field_value = (
        this.fieldData.field_type.indexOf('email') !== -1 &&
        this.fieldData.field_value.indexOf('@example.com') !== -1 ?
          '' :
          this.fieldData.field_value
      ); // TODO: Use config value
    }
  },
  watch: {
    'fieldData.field_value': function fieldValue() {
      this.clearMessages();
    },
  },
};
</script>

<style scoped>
  .input-group input[type=number]::-webkit-inner-spin-button,
  .input-group input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  .input-group input[type=number] {
    -moz-appearance:textfield; /* Firefox */
    border-radius: 0.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputInteger.vue?58f8b1fb